module.exports = __webpack_public_path__ + "img/bg-section-10-mobile.da4cb81f.svg";